import type {
  SettingsData,
  TableEditorMetadata,
  TableImporterMetadata
} from '@stratumn/studio-shared';

const sharedTableSettingsData = {
  allowColumnsSelection: true,
  showEmptyTable: true,
  sortSetup: {
    columnReference: undefined,
    direction: 'ASC'
  }
} as const satisfies SettingsData;

export const overviewSettingsData: SettingsData = sharedTableSettingsData;

export const editorSettingsData: TableEditorMetadata['settings'] = {
  ...sharedTableSettingsData,
  addInitialData: true,
  initialDataKey: 'initialData',
  modifiedDataKey: 'modifiedData',
  allowColumnsSelection: false,
  addComments: true,
  commentKey: 'comment'
};

export const importerSettingsData: TableImporterMetadata['settings'] = {
  ...sharedTableSettingsData,
  allowColumnsSelection: false,
  addFile: true,
  fileKey: 'file',
  addComments: true,
  commentKey: 'comment',
  parsing: {
    encoding: 'latin1',
    csvParser: {
      delimiter: ';'
    }
  },
  aggregation: {}
};
